import { render, staticRenderFns } from "./vehiclePositioning.vue?vue&type=template&id=4222b0f6&scoped=true"
import script from "./vehiclePositioning.vue?vue&type=script&lang=js"
export * from "./vehiclePositioning.vue?vue&type=script&lang=js"
import style0 from "./vehiclePositioning.vue?vue&type=style&index=0&id=4222b0f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4222b0f6",
  null
  
)

export default component.exports